import HeroBanner from './HeroBanner/HeroBanner';
import ProductListing from './ProductListing/ProductListing';

import { HOMEPAGE_IMG_1 } from '../../../src/assets/images/homepage';

import { useEffect } from 'react';
import { getProducts } from '../../../commons/utils/productsHelper';
import { productsKeyConstants } from '../../../config';
import { useAppSelector } from '../../../src/app/hooks';
import { GAPageViewItem } from '../../../commons/helpers/Analytics/googleAnalytics';
import { FBViewContent } from '../../../commons/helpers/Analytics/fbPixel';
import { ipAddressInfo } from '../../../src/features/user/userState';
import { PinterestPageVisit } from '../../../commons/helpers/Analytics/pinterest';
export default function PlpPage() {
  const products = getProducts();
  const ipaddress = useAppSelector(ipAddressInfo);
  const quickStartTag = productsKeyConstants.RF_RELIEF_FACTOR_QS_NEC;
  const rfsingleTag = productsKeyConstants.RF_RELIEF_FACTOR_60_CT_NEC;
  const goSubscription = productsKeyConstants.RF_GO_FACTOR;
  const goSingle = productsKeyConstants.RF_GO_FACTOR_SINGLE;
  const zenSubscription = productsKeyConstants.RF_ZEN_FACTOR;
  const zenSingle = productsKeyConstants.RF_ZEN_FACTOR_SINGLE;

  const zSubscription = productsKeyConstants.RF_Z_FACTOR;
  const zSingle = productsKeyConstants.RF_Z_FACTOR_SINGLE;

  useEffect(() => {
    if (products) {
      GAPageViewItem(
        [
          quickStartTag,
          rfsingleTag,
          goSubscription,
          goSingle,
          zenSubscription,
          zenSingle,
          zSubscription,
          zSingle,
        ],
        products
      );
      PinterestPageVisit(
        [
          quickStartTag,
          rfsingleTag,
          goSubscription,
          goSingle,
          zenSubscription,
          zenSingle,
          zSubscription,
          zSingle,
        ],
        products
      );
    }
  }, [products]);

  useEffect(() => {
    if (ipaddress !== null) {
      FBViewContent(
        [
          quickStartTag,
          rfsingleTag,
          goSubscription,
          goSingle,
          zenSubscription,
          zenSingle,
        ],
        products
      );
      FBViewContent([zSubscription, zSingle], products, true);
    }
  }, [ipaddress]);

  const MainTitle = 'Find the Solutions to Solve Your Problems.';
  const subTitle = 'Shop All Products';

  return (
    <>
      <HeroBanner
        heroImg={HOMEPAGE_IMG_1}
        showBlur
        MainTitle={MainTitle}
        subTitle={subTitle}
      />
      <ProductListing />
    </>
  );
}
